import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getLedgerWalletTransactions } from 'services/LedgerService'
import {
  LedgerWalletTransaction,
  LedgerWalletTransactionsRequestParams,
  LedgerWalletTransactionsResponse,
} from 'types/ledger/ledgerWalletTransactions'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET, withPaginationPaging } from 'utils/pagination'

export const useGetLedgerWalletTransactions = ({
  walletReference,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  start,
  end,
  type,
  enabled = true,
}: LedgerWalletTransactionsRequestParams & { enabled?: boolean }) => {
  return useQuery({
    enabled: enabled,
    queryKey: reactQueryKeys.ledgerWalletTransactions({
      walletReference,
      size,
      page,
      ...(start && { start }),
      ...(end && { end }),
      ...(type && { type }),
    }),
    queryFn: () => getLedgerWalletTransactions({ walletReference, size, page, start, end, type }),
    select: (res: LedgerWalletTransactionsResponse) => {
      const transactionsListWithPagination = withPaginationPaging<LedgerWalletTransaction[]>(res)
      return transactionsListWithPagination
    },
  })
}
